import React from "react";
import { SERVICE_TERMS } from "../data/serviceTerms";

export const ServiceTerms = ({ testId, className = "" }) => (
  <div className={`text-sm text-gray-300 leading-relaxed ${className}`} data-testid={testId}>
    <p data-testid={`${testId}-pricing`}>
      {SERVICE_TERMS.minimumLabel} · {SERVICE_TERMS.deliveryLabel}
    </p>
    <p data-testid={`${testId}-hours`}>{SERVICE_TERMS.restaurantLabel} · Épicerie 24h/24</p>
    <p data-testid={`${testId}-payment`}>{SERVICE_TERMS.paymentLabel}, y compris à Monaco.</p>
  </div>
);